import Script from 'next/script'
import { memo } from 'react'

interface IPropTypes {
  domain: string
}
function PlausibleAnalytics({ domain = '' }: IPropTypes) {
  if (!domain) return null

  return (
    <Script
      defer
      data-domain={domain}
      src='https://plausible.io/js/plausible.js'
    />
  )
}

export default memo(PlausibleAnalytics)
